import * as React from "react";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import './CardAdminDistributeurs.css';
import { Tree, Classes, Intent } from "@blueprintjs/core";
import { Button, Card, Elevation, Overlay } from "@blueprintjs/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CardTable from "./CardTable.tsx";
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
  MultistepDialog,
  DialogStep,
  ButtonProps,
  RadioGroup,
  Radio,
  NumericInput,
  Label,
  FormGroup,
  InputGroup
} from "@blueprintjs/core";
import {IconButton} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CardTableClients from "./CardTableClients.tsx";
import { forEach } from "draft-js/lib/DefaultDraftBlockRenderMap.js";

const passwordLength = 8;
const numbers = '0123456789';
const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
const specialCharacters = "!'^+%&/()=?_#$½§{[]}|;:>÷`<.*-@é";

export default class CardAdminDistributeurs extends React.Component<{}> {
  state = {
    opencreationclient: false,
    password: '',
    nom: '',
    etablissement: '',
    identifiant: '',
    licence: 0,
    users: [],
    licences: [],
    licences_old: [],
    licences_all: [],
    contrats: [],
    all_contrat: [],
    all_contrat_to_Display: [],
    all_users_to_Display: [],
    all_Clients: [],
    must_refresh: false,
    select_id: "",
    select_contrat_id: "",
    opendelete: false,
    openclientdetails: false,
    userdetails: {},
    opencontratdelete: -1,
    nblicenceteachertoadd: 0,
    nblicencestudenttoadd: 0,
    type_licence: 'pro',
    licences_createur:[],
    isOpenCalendar: false,
    date_validation: new Date(),
    reference_name: "",
    recherche_name: "",
    recherche_client_name: "",
    isVisibleVersionLabtice: "none",
    isVisibleAdministration: "none",
    labticeversion: { version: "", description: "" },
  }
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    //console.log(this.props); 
    this.getmyalllicencescreateur();
    this.getmyusers();
    //https://labtice.com/api/public/getmyallusers?id_createur=125
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.must_refresh) {
      this.setState({ must_refresh: false });
      this.getmyusers();
    }
  }
  async handleSendEditClient(id_user) {
    var item = {};
    this.setState({ select_id: id_user })
    try {
      const response = await fetch('/api/public/getclientdetails?id_client=' + id_user);
      const users = await response.json();
      item = users;
    } catch (error) { console.log(error); }
    this.setState({ openclientdetails: true });
    this.setState({ userdetails: item });
    console.log(item);
  }
  async handleOpenDelete(lthis,id)
  {
    lthis.setState({ select_id: id });
    lthis.setState({opendelete:true})
  }
  async handleSendSetModifyUser() {
    var item = {};
    try {
      this.state.users.filter((it) => it.ID == this.state.select_id).map((it) => item = it);
      if (item.ID < 1) return;
      const response = await fetch("/api/public/updateUser", {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      });
      const users = await response.json();
      item = users;
    } catch (error) { console.log(error); }
    console.log(item);
  }
  async handleSendSetClientDetails() {
    var item = {};
    try {
      const response = await fetch("/api/public/updateclientdetails", {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.state.userdetails),
      });
      const users = await response.json();
      item = users;
    } catch (error) { console.log(error); }
    console.log(item);
  }
  async getmyalllicencescreateur() {
    const response = await fetch('/api/public/getmyalllicencesbyidcreateur?id_createur=' + this.props.userid);
    const llicences_createur = await response.json();
    console.log(llicences_createur);
    this.setState({licences_createur:llicences_createur})
    var inberr=0;
    var ll="";
    var it_next_echeance={};
    var next=0;
    var now=new Date().getTime();
    llicences_createur.map((it,index)=>{
      
      if(it.end_date=="")
      {
        inberr++;
        ll+="Labtice "+it.type_produit+" "+it.licence_decrypt+" "+it.type_user+"\n"
      }
      else
      {
        if(next==0){next=index;it_next_echeance=it;}
        it.echeance=it.end_date-now;
      }
    })
    if(inberr>0)
    {
      alert("ATTENTION "+inberr + " licence(s) n'ont pas de date de fin de validité\n"+ll);
      //alert(ll);
    }
    //alert("Prochaine échéance \n"+"Labtice "+it_next_echeance.type_produit+" "+it_next_echeance.licence_decrypt+" "+it_next_echeance.type_user+"\n"+"L'abonnement s'arrête le "+new Date(parseInt(it_next_echeance.end_date)));
  }
  async getmyusers() {
    const response = await fetch('/api/public/getmyallusers?id_createur=' + this.props.userid);
    const users = await response.json();
    console.log(users);
    var objclient = [];
    
    /*const promise = new Promise((resolve, reject) => {
        users.map(async(it,index) => {
        if(promise2!=null)await promise2;
        promise2=null;
        it.identifiant = it.email;
        it.email = "";
        promise2= new Promise((resolve, reject) => {it= this.getClientDetails(it);resolve(it)});
        await promise2[index];
        objclient.push(it);
      });
    });*/
    for  (var i=0;i<users.length;i++)
    {
      var it=users[i];
      it.identifiant = it.email;
      it.email = "";
      var it_details= await this.getClientDetails(it);
      it.id_client_details=it_details.ID;
      it.email=it_details.email;
      it.fonction=it_details.fonction;
      it.nom=it_details.nom;
      it.id_client=it.ID;
      it.ville=it_details.ville;
      it.telephone=it_details.telephone;
      it.mobile=it_details.mobile;
      it.adresse=it_details.adresse;
      it.codepostal=it_details.codepostal;
      it.region=it_details.region;
      it.pays=it_details.pays;
      it.notes=it_details.notes;
      objclient.push(it);
    }
    //const result= await promise
    this.setState({ all_Clients: objclient });
    this.setState({ users: users });
    this.rechercherClient(this.state.recherche_client_name);
    this.getlabticeversion();
    this.getallcontrats();

  }
  getClientDetails = async (user)=>
  {  
    var item = {};
    try {
      
        const response = await fetch("/api/public/getclientdetails?id_user="+user.ID, {
        method: "GET", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
      });
      const users = await response.json();
      item = users;
      user.fonction=item.fonction;
      user.nom=item.nom;
    } catch (error) { console.log(error); }
    return item
  }
  async getlabticeversion() {
    const response = await fetch('/api/public/getlastlabticeversion');
    const llabticeversion = await response.json();
    console.log(llabticeversion);
    this.setState({ labticeversion: llabticeversion });
  }
  async createVersion() {
    if (this.state.labticeversion.version == "") { console.error("Error createVersion: le numéro de version est vide"); return; }
    try {
      const response = await fetch("/api/public/createlabticeversion", {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.state.labticeversion),
      });

      const result = await response.json();
      console.log("Success:", result);
    } catch (error) {
      console.error("Error createVersion:", error);
    }
  }

  async getallcontrats() {
    const response = await fetch('/api/public/getmyallcontrats?id_createur=' + this.props.userid);
    const contrats = await response.json();
    console.log(contrats);
    this.setState({ all_contrat: contrats });
    this.setState({ all_contrat_to_Display: contrats });
    this.setState({ recherche_name: "" })
  }

  async setLicenceToAdd() {
    //return;
    const response = await fetch('/api/public/addLicenceproduit?id_contrat=' + this.state.select_contrat_id + '&id_createur=' + this.props.userid + '&id_administrateur=' + this.state.select_id + '&nb_licence_teacher=' + this.state.nblicenceteachertoadd + '&nb_licence_student=' + this.state.nblicencestudenttoadd + "&produit=" + this.state.type_licence);
    //const users = await response.json();
    setTimeout((ev) => { this.getmyusers(); this.getLicences(this.state.select_contrat_id) }, 2000);
  }
  async setContratToAdd() {
    if (this.state.reference_name == "") return;
    const response = await fetch('/api/public/addContrat?id_createur=' + this.props.userid + '&id_administrateur=' + this.state.select_id + '&reference_name=' + this.state.reference_name + '&id_user=' + this.state.select_id);
    const contrats = await response.json();
    console.log(contrats);
    this.setState({ contrats: contrats });
    this.getallcontrats();
    // setTimeout((ev)=>{this.getmyusers();this.getLicences(this.state.select_id)},2000);
  }

  async getContrats(id_user) {
    this.setState({ select_id: id_user })
    this.setState({ licences: [] });
    this.setState({ contrats: [] });
    this.setState({ nblicencetoadd: 0 })
    const response = await fetch('/api/public/getContrats?id_user=' + id_user);
    const contrats = await response.json();
    console.log(contrats);
    //licences.map((it)=>{if(it.type_produit=="")it.type_produit="pro"});
    this.setState({ contrats: contrats });
    await this.getNbLicences(id_user);
  }
  async getNbLicences(id_administrateur) {
    //this.setState({select_id:id_administrateur})
    this.setState({ licences: [] });
    const response = await fetch('/api/public/getmyalllicences?id_administrateur=' + id_administrateur);
    var licences = await response.json();
    console.log(licences);
    if(licences==null){licences=[]}
    this.setState({ licences_all: licences });
    return licences
  }
  async getNbLicencesWithThis(_this,id_administrateur) {
    //this.setState({select_id:id_administrateur})
    _this.setState({ licences: [] });
    const response = await fetch('/api/public/getmyalllicences?id_administrateur=' + id_administrateur);
    var licences = await response.json();
    if(licences==null)licences=[];
    //console.log(licences);
    var obj=[];
    _this.state.all_Clients.map((it)=>
    {
      if(it.ID==id_administrateur)it.licences_all=licences;
      obj.push(it);
    })
    
    _this.setState({all_Clients:obj})
    if(licences!=null) _this.setState({ licences_all: licences });
    else _this.setState({ licences_all: [] });
    return licences
  }
  async getLicences(id_contrat) {
    this.setState({ select_contrat_id: id_contrat })
    this.setState({ licences: [] });
    this.setState({ nblicencetoadd: 0 })
    const response = await fetch('/api/public/getmyalllicencesbycontrat?id_contrat=' + id_contrat);
    const licences = await response.json();
    console.log(licences);
    licences.map((it) => { if (it.type_produit == "") it.type_produit = "pro" });
    this.setState({ licences: licences });
    //await this.getOldLicences(this.state.select_id);
  }
  async getOldLicences(id_administrateur) {

    this.setState({ licences_old: [] });
    //this.setState({nblicencetoadd:0})
    const response = await fetch('/api/public/getmyalllicences?id_administrateur=' + id_administrateur);
    const licences_old = await response.json();
    //console.log(licences_old);
    var obj = [];
    licences_old.map((it) => {
      if (it.type_produit == "") it.type_produit = "pro"
      if (it.id_contrat == "") obj.push(it);

    });


    this.setState({ licences_old: obj });
  }

  async deleteClient() {
    this.setState({ select_id: "" })
    this.setState({ licences: [] });
    const response = await fetch('/api/public/deluserbyid?id_user=' + this.state.select_id);
    const ret = response.text;
    setTimeout((ev) => this.getmyusers(), 2000);
  }
  handleGeneratePassword = () => {
    let characterList = "";
    characterList = characterList + numbers
    characterList = characterList + upperCaseLetters
    characterList = characterList + lowerCaseLetters
    /*if (includeSymbols) {
      characterList = characterList + specialCharacters
    }*/
    this.setState({ password: this.createPassword(characterList) })

  }
  createPassword = (characterList) => {
    let password = ""
    const characterListLength = characterList.length
    for (let i = 0; i < passwordLength; i++) {
      const characterIndex = Math.round(Math.random() * characterListLength)
      password = password + characterList.charAt(characterIndex)
    }
    return password
  }
  handleChangeNom = (ev) => {
    var valeur = ev.target.value;
    this.setState({ nom: valeur });
  }
  handleChangeEtablissement = (ev) => {
    var valeur = ev.target.value;
    this.setState({ etablissement: valeur });
  }
  handleChangeIdentifiant = (ev) => {
    var valeur = ev.target.value;
    this.setState({ identifiant: valeur });
  }
  handleChangeLicence = (ev) => {
    var valeur = ev.target.value;
    this.setState({ licence: valeur });
  }
  handleNbLicenceToAdd = (val, type_user) => {
    if (type_user == "teacher") this.setState({ nblicenceteachertoadd: val });
    if (type_user == "student") this.setState({ nblicencestudenttoadd: val });
  }
  handleChangeTypeLicence = (ev) => {
    var val = ev.currentTarget.value;
    this.setState({ type_licence: val });
  }
  handleOpenCalendar = (ev) => { ev.preventDefault(); this.setState({ isOpenCalendar: !this.state.isOpenCalendar }); }

  rechercherClient = (rechercheusername) => {
    var obj = [];
    this.setState({ recherche_client_name: rechercheusername })
    this.state.users.map((itu) => {
      if (itu.name.toLowerCase().includes(rechercheusername.toLowerCase())) {
        obj.push(itu);
      }
      if (itu.etablissement.toLowerCase().includes(rechercheusername.toLowerCase())) {
        var bexist = false;
        obj.map((ito) => { if (ito.ID == itu.ID) bexist = true; })
        if (!bexist) obj.push(itu);
      }

    });
    this.setState({ all_users_to_Display: obj });
  }
  rechercherContrat = (recherchename) => {
    var obj = [];
    this.setState({ recherche_name: recherchename })
    this.state.all_contrat.map((itc) => {
      if (itc.reference_name.toLowerCase().includes(recherchename.toLowerCase())) {
        obj.push(itc);
      }
    });
    this.setState({ all_contrat_to_Display: obj });
  }
  handleNewVersion = (num_ver, descrip) => {
    this.state.labticeversion.ID = null;
    this.state.labticeversion.CreatedAt = null;
    this.state.labticeversion.UpdatedAt = null;
    if (num_ver != "") this.state.labticeversion.version = num_ver;
    if (descrip != "") this.state.labticeversion.description = descrip;
    this.setState({ labticeversion: this.state.labticeversion });
  }
  handleChangeModifyUsers = (it) => {
    var obj = [];
    this.state.users.map((ito) => {
      if (ito.ID == it.ID) obj.push(it);
      else obj.push(ito);
    })
    this.setState({ users: obj });
  }
  handleChangeClientDetails = (it) => {

    this.setState({ userdetails: it });
  }
  handleSendCnxAutoLogin = (identifiant, password) => {
    this.props.handleSendCnxAutoLogin(identifiant, identifiant, password);
  }
  handleChangeOldLicenceTypeProduit = (id, type_produit) => {
    var obj = [];
    this.state.licences_old.map((itc) => {
      if (itc.ID == id) itc.type_produit = type_produit;
      obj.push(itc);
    });
    this.setState({ licences_old: obj });
  }
  async modifyLicenceDate(id, date) {
    var timestamp = date.getTime();
    const response = await fetch('/api/public/updateContratDate?id_contrat=' + id + '&timestamp=' + timestamp);
    console.log(timestamp);
    var rech_name = this.state.recherche_name;
    this.getallcontrats();
    //this.setState({recherche_name:rech_name});
    this.rechercherContrat(rech_name);
    this.getContrats(this.state.select_id);
    this.getLicences(id);
  }

  async deleteLicence(id) {
    var l_id = id;
    const response = await fetch('/api/public/deleteLicence?id_licence=' + l_id + '&timestamp=1');
    // console.log(timestamp);
    //var rech_name=this.state.recherche_name;
    this.getallcontrats();
    this.getContrats(this.state.select_id);
    this.getLicences(id);
    //this.setState({recherche_name:rech_name});
    //this.rechercherContrat(rech_name);
    //this.getContrats(this.state.select_id);
    //this.getLicences(id);
  }
  async deleteContrat(id) {
    var l_id = id;
    const response = await fetch('/api/public/deleteContrat?id_contrat=' + l_id + '&timestamp=1');
    // console.log(timestamp);
    //var rech_name=this.state.recherche_name;
    this.getallcontrats();
    this.getContrats(this.state.select_id);
    this.getLicences(id);
    //this.setState({recherche_name:rech_name});
    //this.rechercherContrat(rech_name);
    //this.getContrats(this.state.select_id);
    //this.getLicences(id);
  }
  //handleSendCnxAutoLogin=function(stnickname,stemail,stpass)

  render() {

    //const handleSendCreateUser=function(nickname,name,email,password,licence,matiere,etablissement,role)

    return (
      <div>
        <Card>
          <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
            <IconButton onClick={() => { if (this.state.isVisibleVersionLabtice == 'none') this.setState({ isVisibleVersionLabtice: 'block' }); else this.setState({ isVisibleVersionLabtice: 'none' }); }}>
              {this.state.isVisibleVersionLabtice == 'none' ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
            <H5 onClick={() => { if (this.state.isVisibleVersionLabtice == 'none') this.setState({ isVisibleVersionLabtice: 'block' }); else this.setState({ isVisibleVersionLabtice: 'none' }); }} style={{ cursor: "pointer", margin: '8px 0px' }}>Dernière Version Labtice</H5>
            {this.props.useretablissement.toUpperCase() == "IXILOS" ?
              <Card>
                <div><input onChange={(ev) => { this.handleNewVersion(ev.target.value, "") }} value={this.state.labticeversion.version} type="text" placeholder="Numéro de version"></input></div>
                <div><input onChange={(ev) => { this.handleNewVersion("", ev.target.value) }} value={this.state.labticeversion.description} type="text" placeholder="Description de la version"></input></div>
                <Button onClick={(ev) => { this.createVersion() }}>Valider la nouvelle version</Button>
              </Card> : null}
            <Card style={{ display: this.state.isVisibleVersionLabtice }}>
              <p>Date : {new Date(this.state.labticeversion.UpdatedAt).toLocaleDateString('fr') + " " + new Date(this.state.labticeversion.UpdatedAt).toLocaleTimeString('fr')}</p>
              <p>Numéro de version : {this.state.labticeversion.version}</p>
              <p>Description de la version : {this.state.labticeversion.description}</p>
            </Card>
          </div>
        </Card>

        <Card>
          {this.state.all_Clients.length > 0 ? <CardTableClients handleOpenDelete={this.handleOpenDelete} parent={this} getNbLicences={this.getNbLicencesWithThis} handleSendCnxAutoLogin={this.handleSendCnxAutoLogin} dataclientdetails={this.state.all_Clients}></CardTableClients> : null}
        </Card>
        <Card>
          <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
            <IconButton onClick={() => { if (this.state.isVisibleAdministration == 'none') this.setState({ isVisibleAdministration: 'flex' }); else this.setState({ isVisibleAdministration: 'none' }); }}>
              {this.state.isVisibleAdministration == 'none' ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
            <H5 onClick={() => { if (this.state.isVisibleAdministration == 'none') this.setState({ isVisibleAdministration: 'flex' }); else this.setState({ isVisibleAdministration: 'none' }); }} style={{ cursor: "pointer", margin: '8px 0px' }}>ADMINISTRATION {" " + this.props.useretablissement}</H5>
            <Card style={{ flexWrap: 'wrap', width: '100%', display: this.state.isVisibleAdministration }}>
              <Card style={{ width: '50%', marginBottom: 15 }}>
                <H5>Vos clients</H5>
                <Button style={{ marginBottom: 10, backgroundColor: "#444", color: "#fff", }} onClick={(ev) => { this.handleGeneratePassword(); this.setState({ opencreationclient: !this.state.opencreationclient }); }} icon="plus">Créer un nouveau compte / client administrateur</Button>
                <div style={{ borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0' }}>Rechercher un client : <input value={this.state.recherche_client_name} style={{ marginLeft: 10 }} onChange={(ev) => this.rechercherClient(ev.target.value)} type="text" /></div>
                <div style={{ height: 140, overflow: 'auto' }}>
                  {this.state.all_users_to_Display.map((itc) => <div style={{ cursor: 'pointer', userSelect: 'none', backgroundColor: '#555', margin: 2, color: '#fff', borderRadius: 6, padding: 4 }} onClick={(ev) => { this.getContrats(itc.ID); this.setState({ select_id: itc.ID }); }}><span>Nom du client : {itc.name}</span><span style={{ marginLeft: 25 }}>Nom de l'établissement : {itc.etablissement}</span></div>)}
                </div>
              </Card>
              <Card style={{ width: 'calc( 50% - 15px)', marginBottom: 15, marginLeft: 15 }}>
                <H5>Vos bons de commande</H5>
                <div style={{ borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0' }}>Rechercher un bon de commande : <input value={this.state.recherche_name} style={{ marginLeft: 10 }} onChange={(ev) => this.rechercherContrat(ev.target.value)} type="text" /></div>
                <div style={{ height: 140, overflow: 'auto' }}>
                  {this.state.all_contrat_to_Display.map((itc) => <div style={{ cursor: 'pointer', userSelect: 'none', backgroundColor: '#555', margin: 2, color: '#fff', borderRadius: 6, padding: 4 }} onClick={(ev) => { this.setState({ select_id: itc.id_administrateur }); this.getContrats(itc.id_administrateur); this.getLicences(itc.ID) }}><span>{itc.reference_name}</span><span style={{ marginLeft: 15 }}> contrat crée le {new Date(itc.CreatedAt).toLocaleDateString()}</span><span style={{ marginLeft: 15 }}> contrat valide jusqu'au {new Date(parseInt(itc.end_date)).toLocaleDateString()}</span></div>)}
                </div>
              </Card>

              {this.state.opencreationclient ?
                <Card>
                  <FormGroup helperText=""
                    label="NOM"
                    labelFor="id_nom"
                    labelInfo="*">
                    <InputGroup onChange={(ev) => this.handleChangeNom(ev)} id="id_nom" value={this.state.nom} placeholder="Nom" />
                  </FormGroup>
                  <FormGroup helperText=""
                    label="ETABLISSEMENT"
                    labelFor="id_etablissement"
                    labelInfo="*">
                    <InputGroup onChange={(ev) => this.handleChangeEtablissement(ev)} value={this.state.etablissement} id="id_etablissement" placeholder="Etablissement" />
                  </FormGroup>
                  {/*<FormGroup helperText=""
              label="NOMBRE DE LICENCE"
              labelFor="id_licence"
              subLabel="Nombre de licences enseignants"
              labelInfo="*">
               <InputGroup type="number" onChange={(ev)=>this.handleChangeLicence(ev)} value={this.state.licence} id="id_licence" />
            </FormGroup>*/}
                  <FormGroup intent={Intent.PRIMARY} helperText=""
                    label="IDENTIFIANT"
                    labelFor="id_identifiant"
                    subLabel="Identifiant donné à l'administrateur du site"
                    labelInfo="*">
                    <InputGroup onChange={(ev) => this.handleChangeIdentifiant(ev)} value={this.state.identifiant} id="id_identifiant" placeholder="identifiant admin" />
                  </FormGroup>
                  <FormGroup intent={Intent.DANGER} helperText=""
                    label="MOT DE PASSE"
                    labelFor="id_password"
                    subLabel="Le mot de passe est généré automatiquement"
                    labelInfo="*">
                    <InputGroup value={this.state.password} id="id_password" />
                  </FormGroup>
                  <Button onClick={(ev) => { this.props.handleSendCreateAdmin(this.state.nom, this.state.nom, this.state.identifiant, this.state.password, this.state.licence, this.props.useretablissement, this.state.etablissement, "admin"); this.setState({ opencreationclient: !this.state.opencreationclient }); setTimeout((ev) => this.setState({ must_refresh: true }), 3000); }} disabled={this.state.nom == "" || this.state.etablissement == "" || this.state.identifiant == "" || this.state.password == ""} icon="send-message">Créer le compte admin</Button>
                </Card> : null}
              <Card>
                {this.state.users.map(it =>
                  <div style={{ borderRadius: 6, display: (this.state.select_id == "" || it.ID == this.state.select_id) ? "block" : "none", padding: 12, backgroundColor: '#efe', boxShadow: '0 0 3px 1px #000', marginTop: 8 }}><Button style={{ margin: 5, backgroundColor: '#444' }} onClick={(ev) => { if (this.state.select_id == it.ID) { this.setState({ select_id: "" }); } else this.getContrats(it.ID) }} icon={it.ID == this.state.select_id ? "minus" : "plus"} /><span>Nom: {it.name}</span><span style={{ marginLeft: 10 }}>Etablissement: {it.etablissement}</span><span style={{ marginLeft: 10 }}>Identifiant de l'administrateur du site: {it.identifiant}</span><span style={{ marginLeft: 10 }}>Mot de passe: {it.password}</span>
                    {/*<Button style={{ backgroundColor: "#444", color: "#fff", marginLeft: 15 }} onClick={(ev) => { this.handleSendEditClient(it.ID) }} icon="edit"></Button>*/}
                    <Button style={{ backgroundColor: "#444", color: "#fff", marginLeft: 15 }} onClick={(ev) => { this.props.handleSendCnxAutoLogin(it.identifiant, it.identifiant, it.password) }} icon="log-in">Se connecter</Button>
                    <Button style={{ backgroundColor: "#444", color: "#fff", marginLeft: 15 }} onClick={(ev) => { this.setState({ select_id: it.ID }); this.setState({ opendelete: true }) }} icon="trash"></Button>
                    <div>
                      {it.ID == this.state.select_id ? this.state.licences_all.length > 0 ? <div style={{ borderRadius: 6, backgroundColor: '#ccc', padding: '10px 10px 5px', margin: '10px 0' }}>
                        {this.state.licences_all.filter((itf) => itf.type_produit == "pro").length > 0 ? <div>
                          <div>Nombre de licence(s) totale(s) de Labtice Pro : {this.state.licences_all.filter((itf) => itf.type_produit == "pro").length}</div>
                          <div>Dont licence(s) tuteur totale(s) de Labtice Pro : {this.state.licences_all.filter((itf) => itf.type_produit == "pro").filter((itf) => itf.type_user == "teacher").length}</div>
                          <div>Dont licence(s) apprenant(s) totale(s) de Labtice Pro : {this.state.licences_all.filter((itf) => itf.type_produit == "pro").filter((itf) => itf.type_user == "student").length}</div>
                          <br />
                        </div> : null}
                        {this.state.licences_all.filter((itf) => itf.type_produit == "basic").length > 0 ? <div>
                          <div>Nombre de licence(s) totale(s) de Labtice Basic : {this.state.licences_all.filter((itf) => itf.type_produit == "basic").length}</div>
                          <div>Dont licence(s) tuteur totale(s) de Labtice Basic : {this.state.licences_all.filter((itf) => itf.type_produit == "basic").filter((itf) => itf.type_user == "teacher").length}</div>
                          <div>Dont licence(s) apprenant(s) totale(s) de Labtice Basic : {this.state.licences_all.filter((itf) => itf.type_produit == "basic").filter((itf) => itf.type_user == "student").length}</div>
                        </div> : null}
                      </div> : null : null}
                      {it.ID == this.state.select_id ? <div style={{ borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0' }}>Référence du bon de commande :<input value={this.state.reference_name} style={{ marginLeft: 10 }} onChange={(ev) => this.setState({ reference_name: ev.target.value })} type="text" /><Button style={{ marginLeft: 5 }} onClick={(ev) => this.setContratToAdd()} disabled={this.state.reference_name == ""} icon="small-plus">Créer un contrat</Button></div> : null}
                      {it.ID == this.state.select_id ? this.state.contrats.length > 0 ?
                        this.state.contrats.map((itcontrat) =>
                          <div style={{ borderRadius: 6, backgroundColor: '#c7dbd3', padding: '10px 10px 5px', margin: '10px 0 10px 20px' }}>
                            <Button style={{ margin: 5, backgroundColor: '#444' }} onClick={(ev) => { if (this.state.select_contrat_id == itcontrat.ID) { this.setState({ select_contrat_id: "" }); } else { this.getLicences(itcontrat.ID) } }} icon={itcontrat.ID == this.state.select_contrat_id ? "minus" : "plus"} />
                            Référence du bon de commande :<span><b>{itcontrat.reference_name}</b></span><Button style={{ backgroundColor: "#444", color: "#fff", marginLeft: 5 }} onClick={(ev) => { this.setState({ opencontratdelete: itcontrat.ID }) }} icon="trash" />
                            {itcontrat.ID == this.state.select_contrat_id ? <div style={{ borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0' }}>Type de Licences <RadioGroup className="clRadioGroup" onChange={this.handleChangeTypeLicence} selectedValue={this.state.type_licence} inline={true}> <Radio label="PRO" value="pro"></Radio><Radio inline={true} label="BASIC" value="basic"></Radio></RadioGroup>
                              <span> <div style={{ marginLeft: 10 }} >Nombre de Licence(s) tuteur(s)<input style={{ marginLeft: 36 }} value={this.state.nblicenceteachertoadd} onChange={(ev) => this.handleNbLicenceToAdd(ev.target.value, "teacher")} type="number" /></div>
                                <div style={{ marginLeft: 10 }} >Nombre de Licence(s) apprenant(s)<input value={this.state.nblicencestudenttoadd} style={{ marginLeft: 10 }} onChange={(ev) => this.handleNbLicenceToAdd(ev.target.value, "student")} type="number" /></div>
                              </span>
                              <Button style={{ marginLeft: 5 }} onClick={(ev) => this.setLicenceToAdd()} disabled={(this.state.nblicenceteachertoadd + this.state.nblicencestudenttoadd) <= 0} icon="small-plus">Ajouter des licences</Button></div> : null}
                            {itcontrat.ID == this.state.select_contrat_id ? this.state.licences.length > 0 ?
                              <div style={{ borderRadius: 6, backgroundColor: '#e9c0c0', padding: '10px 10px 5px', margin: '10px 0' }}>
                                <Button style={{ backgroundColor: "#444", color: "#fff" }} onClick={this.handleOpenCalendar} icon="calendar">Date de validité des licences</Button>
                                <span style={{ marginLeft: 10 }}>licences valident jusqu'au
                                  {this.state.isOpenCalendar ?
                                    <DatePicker selected={this.state.date_validation} onChange={(date) => { this.setState({ date_validation: date }); this.modifyLicenceDate(itcontrat.ID, date); this.setState({ isOpenCalendar: false }); }} inline showYearDropdown dateFormatCalendar="MMMM" yearDropdownItemNumber={5} scrollableYearDropdown />
                                    : <span style={{ marginLeft: 5 }}>{new Date(parseInt(itcontrat.end_date)).toLocaleDateString()}</span>
                                  }
                                </span>
                              </div> : null : null}
                            {itcontrat.ID == this.state.select_contrat_id ? <div><span style={{ display: 'inline-flex', justifyContent: 'center', backgroundColor: "#444", color: "#fff", padding: 10, margin: '4px 4px 4px 4px', width: '49%' }}>{this.state.licences.filter((itf) => itf.type_produit == "pro").length} LICENCES PRO  DONT {this.state.licences.filter((itf) => itf.type_produit == "pro").filter((itf) => itf.type_user == "teacher").length} licence(s) tuteur(s) et {this.state.licences.filter((itf) => itf.type_produit == "pro").filter((itf) => itf.type_user == "student").length} licence(s) apprenant(s)</span><span style={{ display: 'inline-flex', justifyContent: 'center', backgroundColor: "#444", color: "#fff", padding: 10, margin: '4px 4px 4px 4px', width: '49%' }}>{this.state.licences.filter((itf) => itf.type_produit == "basic").length} LICENCES BASIC DONT {this.state.licences.filter((itf) => itf.type_produit == "basic").filter((itf) => itf.type_user == "teacher").length} licence(s) tuteur(s) et {this.state.licences.filter((itf) => itf.type_produit == "basic").filter((itf) => itf.type_user == "student").length} licence(s) apprenant(s)</span></div> : null}
                            {itcontrat.ID == this.state.select_contrat_id ? this.state.licences.map((it2, i) =>
                              it2.type_produit == "pro" ? <div style={{ overflow: 'auto', padding: 10, margin: '4px 4px 4px 4px', width: '49%', backgroundColor: it2.id_user == 0 ? it2.type_user == "teacher" ? '#b5d7c9' : "#ccc" : '#fcc', borderRadius: 4 }}><Button style={{ backgroundColor: "#444", color: "#fff" }} icon="trash" onClick={(ev) => this.deleteLicence(it2.ID)}></Button>  Licence <b>{it2.type_produit} {it2.type_user} </b> {(i + 1) + ": "}<b>{it2.licence}</b><div>créé le: {new Date(it2.CreatedAt).toLocaleDateString('fr')}<span style={{ marginLeft: 15 }}>valide jusqu'au {new Date(parseInt(it2.end_date)).toLocaleDateString()}</span> <b> Licence {it2.id_user == 0 ? "libre" : "utilisée"}</b></div></div>
                                : <div style={{ overflow: 'auto', padding: 10, margin: '4px 4px 4px 50%', width: '49%', backgroundColor: it2.id_user == 0 ? it2.type_user == "teacher" ? '#b5d7c9' : "#ccc" : '#fcc', borderRadius: 4 }}><Button style={{ backgroundColor: "#444", color: "#fff" }} icon="trash" onClick={(ev) => this.deleteLicence(it2.ID)}></Button>  Licence <b>{it2.type_produit} {it2.type_user} </b> {(i + 1) + ": "}<b>{it2.licence}</b><div>créé le: {new Date(it2.CreatedAt).toLocaleDateString('fr')} <span style={{ marginLeft: 15 }}>valide jusqu'au {new Date(parseInt(it2.end_date)).toLocaleDateString()}</span> <b> Licence {it2.id_user == 0 ? "libre" : "utilisée"}</b></div></div>) : null
                            }
                            {/*itcontrat.ID==this.state.select_contrat_id?<div><span style={{display: 'inline-flex',justifyContent: 'center',backgroundColor:"#444",color:"#fff", padding:10,margin:'4px 4px 4px 4px',width:'100%'}}>{this.state.licences_old.length} ANCIENNES LICENCES SANS CONTRAT NI DE TYPE PRODUIT NI DE DATE DE VALIDATION</span></div>:null*/}
                            {/*itcontrat.ID==this.state.select_contrat_id?this.state.licences_old.length>0?this.state.licences_old.map((it2,i)=>
                  <div style={{padding:10,margin:'4px 4px 4px 4px',width:'100%',backgroundColor:it2.id_user==0?'#b5d7c9':'#fcc',borderRadius:4}}>Licence  {(i+1)+": "}<b>{it2.licence}</b><div>créé le: {new Date(it2.CreatedAt).toLocaleDateString('fr')} <select style={{marginLeft:15,padding:5}} onChange={(ev)=>this.handleChangeOldLicenceTypeProduit(it2.ID,ev.target.value)} defaultValue="pro"><option value="pro">Labtice Pro</option><option value="basic">Labtice Basic</option></select><Button style={{marginLeft:15}} icon="add">Ajouter au contrat {itcontrat.reference_name}</Button></div></div>
                  ):null:null
              */}
                          </div>) : null : null}
                      {/*it.ID==this.state.select_id?<div style={{borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0'}}>Nombre de licences <RadioGroup className="clRadioGroup" onChange={this.handleChangeTypeLicence} selectedValue={this.state.type_licence} inline={true}> <Radio  label="PRO" value="pro"></Radio><Radio inline={true} label="BASIC" value="basic"></Radio></RadioGroup><span>à ajouter</span><input value={this.state.nblicencetoadd} style={{marginLeft:10}} onChange={(ev)=>this.handleNbLicenceToAdd(ev.target.value)} type="number"/><Button style={{marginLeft:5}} onClick={(ev)=>this.setLicenceToAdd()} disabled={this.state.nblicencetoadd<=0} icon="small-plus">Ajouter des licences</Button></div>:null*/}
                      {/*it.ID==this.state.select_id?this.state.licences.length>0?<div style={{borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0'}}><Button onClick={this.handleOpenCalendar} icon="calendar">Date de validité des licences</Button><span style={{marginLeft:10}}>licences valident jusqu'au {this.state.isOpenCalendar?<DatePicker inline showYearDropdown  dateFormatCalendar="MMMM"  yearDropdownItemNumber={5} scrollableYearDropdown />:null}</span></div>:null:null*/}
                      {/*it.ID==this.state.select_id?<div><span style={{display: 'inline-flex',justifyContent: 'center',backgroundColor:"#444",color:"#fff", padding:10,margin:'4px 4px 4px 4px',width:'49%'}}>LICENCES PRO</span><span style={{display: 'inline-flex',justifyContent: 'center',backgroundColor:"#444",color:"#fff", padding:10,margin:'4px 4px 4px 4px',width:'49%'}}>LICENCES BASIC</span></div>:null*/}
                      {/*it.ID==this.state.select_id?this.state.licences.map((it2,i)=>
                it2.type_produit=="pro"?<div style={{padding:10,margin:'4px 4px 4px 4px',width:'49%',backgroundColor:it2.id_user==0?'#b5d7c9':'#fcc',borderRadius:4}}>Licence {it2.type_produit} {(i+1)+": "}<b>{it2.licence}</b><div>créé le: {new Date(it2.CreatedAt).toLocaleDateString('fr')}</div></div>
                :<div style={{padding:10,margin:'4px 4px 4px 50%',width:'49%',backgroundColor:it2.id_user==0?'#b5d7c9':'#fcc',borderRadius:4}}>Licence {it2.type_produit} {(i+1)+": "}<b>{it2.licence}</b><div>créé le: {new Date(it2.CreatedAt).toLocaleDateString('fr')}</div></div>
                ):null}</div></div>)
              */}
                    </div></div>)}
              </Card>
            </Card>
          </div>
        </Card>
        {this.state.all_contrat_to_Display.length>0?<Card>
        <div style={{ display: 'block', flexWrap: 'wrap', flexDirection: 'row' }}>
        <h3>Les futures échéances</h3>
        <div style={{height:25}}><span style={{position:'absolute',left:'10px',border: '1px solid #bbb',width: 690, textAlign: 'center'}}>Date des Licences</span><span style={{position:'absolute',left:'700px',border: '1px solid #bbb',width: 400, textAlign: 'center'}}>nom du client</span><span style={{position:'absolute',left:'1100px',border: '1px solid #bbb',width: 400, textAlign: 'center'}}>nom du contrat</span></div>
        {this.state.licences_createur.filter((it)=>it.type_user=="teacher").map((it,index)=>
          this.state.all_contrat_to_Display.filter((itf)=>(itf.ID==it.id_contrat))[0] !=undefined?this.state.all_Clients.filter((itfc)=>itfc.ID==this.state.all_contrat_to_Display.filter((itf)=>(itf.ID==it.id_contrat))[0].id_administrateur)[0] !=undefined?<div style={{height:25}}><span style={{backgroundColor:it.echeance<=0?"#FAA":it.echeance>(60000*60*24*90)?"#AFA":'#f1b55c',position:'absolute',left:'10px',border: '1px solid #bbb',width: 690, textAlign: 'left'}}>{new Date(parseInt(it.end_date)).toLocaleDateString()+ " Labtice "+it.type_produit+" "+it.licence_decrypt+" "+it.type_user}</span><span style={{paddingLeft:10,position:'absolute',width: 400,border: '1px solid #bbb',left:'700px',cursor:'pointer'}}><b>{this.state.all_Clients.filter((itfc)=>itfc.ID==this.state.all_contrat_to_Display.filter((itf)=>(itf.ID==it.id_contrat))[0].id_administrateur)[0].name}</b></span><span style={{paddingLeft:10,width: 400,border: '1px solid #bbb',position:'absolute',left:'1100px',cursor:'pointer'}}>{this.state.all_contrat_to_Display.filter((itf)=>(itf.ID==it.id_contrat))[0].reference_name}</span></div>:null:null
        )}
        </div>
        </Card>:null}
        <Overlay isOpen={this.state.openclientdetails} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px', width: '90%', margin: '30px 5%' }}>

            <H5>EDITION de la fiche client </H5>
            {this.state.users.filter((it) => it.ID == this.state.select_id).map((it) =>
              <div>
                <div style={{ padding: '10px 5px' }}>Nom : <input onChange={(ev) => { it.name = ev.target.value; this.handleChangeModifyUsers(it); }} style={{ position: 'absolute', left: 160 }} value={it.name} /></div>
                <div style={{ padding: '10px 5px' }}>Nom établissement: <input style={{ position: 'absolute', left: 160 }} value={it.etablissement} /></div>
                <div style={{ padding: '10px 5px' }}>identifiant : <input style={{ position: 'absolute', left: 160 }} value={it.identifiant} /></div>
                <div style={{ padding: '10px 5px' }}>mot de passe : <span style={{ position: 'absolute', left: 160 }}>{it.password}</span></div>
                <div style={{ padding: '10px 5px' }}>Nom du contact : <input onChange={(ev) => { this.state.userdetails.nom = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.nom} /></div>
                <div style={{ padding: '10px 5px' }}>Fonction : <input onChange={(ev) => { this.state.userdetails.fonction = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.fonction} /></div>
                <div style={{ padding: '10px 5px' }}>Email : <input onChange={(ev) => { this.state.userdetails.email = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.email} /></div>
                <div style={{ padding: '10px 5px' }}>Téléphone : <input onChange={(ev) => { this.state.userdetails.telephone = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.telephone} /></div>
                <div style={{ padding: '10px 5px' }}>Tél mobile : <input onChange={(ev) => { this.state.userdetails.mobile = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.mobile} /></div>
                <div style={{ padding: '10px 5px' }}>Adresse : <input onChange={(ev) => { this.state.userdetails.adresse = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.adresse} /></div>
                <div style={{ padding: '10px 5px' }}>Code postal : <input onChange={(ev) => { this.state.userdetails.codepostal = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.codepostal} /></div>
                <div style={{ padding: '10px 5px' }}>Région : <input onChange={(ev) => { this.state.userdetails.region = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.region} /></div>
                <div style={{ padding: '10px 5px' }}>Ville : <input onChange={(ev) => { this.state.userdetails.ville = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.ville} /></div>
                <div style={{ padding: '10px 5px' }}>Pays : <input onChange={(ev) => { this.state.userdetails.pays = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} style={{ position: 'absolute', left: 160 }} value={this.state.userdetails.pays} /></div>
                <div style={{ padding: '10px 5px' }}>Notes complémentaires : <input onChange={(ev) => { this.state.userdetails.notes = ev.target.value; this.handleChangeClientDetails(this.state.userdetails); }} value={this.state.userdetails.notes} /></div>
              </div>)}

            <Button intent={Intent.SUCCESS} onClick={(ev) => { ev.preventDefault(); this.handleSendSetClientDetails(); this.setState({ openclientdetails: false }) }} style={{ margin: 4 }}>
              Modifier
            </Button>
            <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); this.setState({ openclientdetails: false }) }} style={{ margin: 4 }}>
              Annuler
            </Button>
          </div>
        </Overlay>
        <Overlay isOpen={this.state.opendelete} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px', width: '90%', margin: '30px 5%' }}>

            <H5>ATTENTION vous allez effacer toutes les licences et le compte du client: </H5>
            {this.state.users.filter((it) => it.ID == this.state.select_id).map((it) => <div><b>{it.name}</b>
              <div><H5>TOUS les enseignants de ce client {it.name} n'auront plus accès à LABTICE</H5></div></div>)}
            <Button intent={Intent.WARNING} onClick={(ev) => { ev.preventDefault(); this.setState({ opendelete: false }); this.deleteClient() }} style={{ margin: 4 }}>
              Je veux effacer ce client
            </Button>
            <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); this.setState({ opendelete: false }) }} style={{ margin: 4 }}>
              Annuler
            </Button>
          </div>
        </Overlay>
        <Overlay isOpen={this.state.opencontratdelete > 0} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px', width: '90%', margin: '30px 5%' }}>

            <H5>ATTENTION vous allez effacer le contrat et toutes ses licences</H5>
            <Button intent={Intent.WARNING} onClick={(ev) => { ev.preventDefault(); this.deleteContrat(this.state.opencontratdelete); this.setState({ opencontratdelete: 0 }); }} style={{ margin: 4 }}>
              Je veux effacer ce contrat
            </Button>
            <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); this.setState({ opencontratdelete: 0 }) }} style={{ margin: 4 }}>
              Annuler
            </Button>
          </div>
        </Overlay>
      </div>);
  }
}
